import styled from 'styled-components';

export default styled.span`
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 30px;
  color: #fff;
  margin-top: 10px;
`;
